interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignment} gap-3`}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
          {eyebrow}
        </span>
      ) : null}
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-balance">
        {title}
      </h2>
      {desc ? (
        <p className="max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}